// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Disk_diskCard__Fp3hL {
  margin-bottom: 20px;
}
.Disk_diskCard__Fp3hL .ant-card-head-title {
  font-weight: bold;
}

.Disk_usageBar__b4KdP {
  margin-top: 4px;
  margin-bottom: 4px;
}

.Disk_criticalUsage__YCxmq {
  color: #ff4d4f;
  font-weight: bold;
}

.Disk_warningUsage__cgGnq {
  color: #faad14;
  font-weight: bold;
}

.Disk_normalUsage__lpP2N {
  color: #52c41a;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/disk/Disk.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,eAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":[".diskCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.usageBar {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n\n.criticalUsage {\n  color: #ff4d4f;\n  font-weight: bold;\n}\n\n.warningUsage {\n  color: #faad14;\n  font-weight: bold;\n}\n\n.normalUsage {\n  color: #52c41a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"diskCard": `Disk_diskCard__Fp3hL`,
	"usageBar": `Disk_usageBar__b4KdP`,
	"criticalUsage": `Disk_criticalUsage__YCxmq`,
	"warningUsage": `Disk_warningUsage__cgGnq`,
	"normalUsage": `Disk_normalUsage__lpP2N`
};
export default ___CSS_LOADER_EXPORT___;
